import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'kis-submit-button',
  templateUrl: './submit-button.component.html',
  styleUrls: ['./submit-button.component.scss']
})
export class SubmitButtonComponent implements OnInit {

  /** Shows loader */
  @Input()
  loading = false;

  /** Disables button */
  @Input()
  disabled = false;

  /** Type of background */
  @Input()
  theme = 'light';

  /** Click event */
  @Output()
  submit = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

}
